/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'star-outline': {
    width: 22,
    height: 22,
    viewBox: '0 0 22 22',
    data: '<path pid="0" d="M21.166 9.62h0c.303-.309.41-.763.278-1.19-.13-.42-.464-.713-.871-.775l-5.327-.808a1.198 1.198 0 01-.901-.678l-2.382-5.038A1.064 1.064 0 0011 .5c-.409 0-.777.239-.962.631L7.656 6.17a1.2 1.2 0 01-.902.679l-5.327.808c-.407.061-.74.355-.871.775-.133.426-.025.88.278 1.189l3.854 3.921c.277.282.402.684.338 1.075l-.91 5.538c-.057.347.028.677.24.94.322.4.879.516 1.316.276l4.764-2.615c.348-.19.78-.19 1.129 0l4.765 2.615c.158.087.322.13.493.13.312 0 .611-.146.822-.407.211-.261.296-.592.239-.94l-.91-5.536c-.064-.393.06-.794.338-1.076l3.854-3.921z" _stroke="#A9B7C3" _fill="none" fill-rule="evenodd"/>'
  }
})
